import React from 'react';
import { useContent } from '../../hooks/useContent';
import LoadingSpinner from '../common/LoadingSpinner';
import ErrorMessage from '../common/ErrorMessage';

const Blog = () => {
    const { content, isLoading, isError, error, loadContentBySection } = useContent('blog');

    // Get the blog content data
    const blogData = content.length > 0 ? content[0].content_data : null;

    if (isLoading) {
        return (
            <div className="row justify-content-center">
                <div className="col-12">
                    <LoadingSpinner size="lg" />
                </div>
            </div>
        );
    }

    if (isError) {
        return (
            <div className="row justify-content-center">
                <div className="col-12">
                    <ErrorMessage error={error} onRetry={() => loadContentBySection('blog')} />
                </div>
            </div>
        );
    }

    if (!blogData) {
        return (
            <div className="row justify-content-center">
                <div className="col-12">
                    <div className="text-center">
                        <p>No blog content available.</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div>
            <div className="row">
                {blogData.blogData && blogData.blogData.map((item, idx) => (
                    <div key={`bt_${idx}`} className="col-12 col-md-6">
                        {/* Single Blog */}
                        <div className="single-blog res-margin">
                            {/* Blog Thumb */}
                            <div className="blog-thumb">
                                <a href="/#"><img src={item.image} alt={item.title} /></a>
                            </div>
                            {/* Blog Content */}
                            <div className="blog-content p-4">
                                {/* Meta Info */}
                                <ul className="meta-info d-flex justify-content-between">
                                    <li>By <a className="text-primary" href="/#">{item.author}</a></li>
                                    <li><a href="/#">{item.date}</a></li>
                                </ul>
                                {/* Blog Title */}
                                <h3 className="blog-title my-3"><a href="/#">{item.title}</a></h3>
                                <p>{item.excerpt}</p>
                                <a href="/#" className="blog-btn mt-3">Read More</a>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <div className="row">
                <div className="col-12">
                    {/* Pagination */}
                    <ul className="pagination justify-content-center py-4">
                        <li className="disabled px-1">
                            <a href="/#" aria-label="Previous">
                                <i className="fas fa-arrow-left" />
                            </a>
                        </li>
                        <li className="px-1"><a href="/#">1</a></li>
                        <li className="active px-1"><a href="/#">2</a></li>
                        <li className="px-1"><a href="/#">3</a></li>
                        <li>
                            <a href="/#" aria-label="Next">
                                <i className="fas fa-arrow-right" />
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Blog;